import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

export interface UpdateCommentTRPCInput {
  Id: string;
  Content: string;
}

export const useUpdateCommentTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.comment.update.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.comment.commentsByConversationId.queryKey(),
        });
      },
    }),
  });

  return {
    updateComment: async (
      input: UpdateCommentTRPCInput
    ): Promise<{ Id: string }> => mutation.mutateAsync(input),
    loading: mutation.isPending,
    error: mutation.error,
  };
};
